// extracted by mini-css-extract-plugin
module.exports = {"leftside":"ParentProductCard_leftside__nT11_"};